/**
 * Centralized React Query keys for consistent cache management.
 * Using a factory pattern ensures type safety and consistent key structure.
 */

export const queryKeys = {
  // Blocks
  blocks: {
    all: ['blocks'] as const,
    byDate: (userId: string | undefined, date: string) => ['blocks', userId, date] as const,
  },

  // Weekly Plans
  weeklyPlan: {
    all: ['weeklyPlan'] as const,
    byWeek: (userId: string | undefined, weekId: string) => ['weeklyPlan', userId, weekId] as const,
  },

  // Tasks
  tasks: {
    all: ['tasks'] as const,
    byUser: (userId: string | undefined) => ['tasks', userId] as const,
  },

  // Captures
  captures: {
    all: ['captures'] as const,
    byUser: (userId: string | undefined) => ['captures', userId] as const,
  },

  // Daily MITs
  dailyMITs: {
    all: ['dailyMITs'] as const,
    byDate: (userId: string | undefined, date: string) => ['dailyMITs', userId, date] as const,
  },

  // Revision Logs
  revisionLog: {
    all: ['revisionLog'] as const,
    byDate: (userId: string | undefined, date: string) => ['revisionLog', userId, date] as const,
  },

  // Metrics
  metrics: {
    daily: (userId: string | undefined, date: string) => ['dailyMetrics', userId, date] as const,
    weekly: (userId: string | undefined, weekId: string) =>
      ['weeklyMetrics', userId, weekId] as const,
  },

  // User Settings
  user: {
    settings: (userId: string | undefined) => ['userSettings', userId] as const,
    profile: (userId: string | undefined) => ['userProfile', userId] as const,
  },

  // Days
  days: {
    all: ['days'] as const,
    byDate: (userId: string | undefined, date: string) => ['days', userId, date] as const,
  },
} as const;

// Helper type for extracting query key types
export type QueryKeyFactory = typeof queryKeys;
